/*
 * Copyright (C) 2026 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

// Handlebars templates render once and never re-render when a namespace
// arrives late, so a router-served route must declare what it reaches.
export const OUTCOMES_MANAGEMENT_NAMESPACES = [
  'collection_view',
  'move_outcome_dialog',
  'outcomes_browser',
  'outcomes_calculation_method_example',
  'outcomes_criterion',
  'outcomes_criterion_header',
  'outcomes_no_outcomes_warning',
  'outcomes_outcome_calculation_method_form',
  'outcomes_outcome_form',
  'paginated_collection',
  'paginated_view',
  'tree_browser',
  'tree_collection',
  'tree_item',
]

export const ASSIGNMENT_EDIT_NAMESPACES = [
  ...OUTCOMES_MANAGEMENT_NAMESPACES,
  'assignments_due_date_override',
  'assignments_edit_header_view',
  'assignments_edit_view',
  'assignments_submission_types_form',
  'jquery_module_sequence_footer',
]
